export enum AssetStatusName {
  production = 'production',
  maintenance = 'maintenance',
  decommissioned = 'decommissioned',
  project = 'project',
  probation = 'probation'
}
